import React from 'react';
import {connect} from 'react-redux';
import DataSourceFilters from 'components/DataSourceFilters';
import {selectDataSourceIdByCardId} from 'state/dataSource/dataSourceSelectors';
import {
  selectFiltersByCardId,
  selectFilterGroupsByCardId,
} from 'state/cardFilter/cardFilterSelectors';
import {loadDataSourcesByCardId} from 'state/dataSource/dataSourceActions';
import {
  addCardFilter,
  removeCardFilter,
  applyCardFilter,
  applyCardFilterGroups,
} from 'state/cardFilter/cardFilterActions';

class CardDataSourceFilters extends React.Component {
  componentDidMount() {
    this.props.loadDataSourcesByCardId(this.props.cardId);
  }

  UNSAFE_componentWillReceiveProps({cardId}) {
    if (this.props.cardId !== cardId) {
      this.props.loadDataSourcesByCardId(cardId);
    }
  }

  handleAdd = filterId => {
    this.props.addCardFilter(
      this.props.cardId,
      this.props.dataSourceId,
      filterId
    );
  };

  handleRemove = filterId => {
    this.props.removeCardFilter(this.props.cardId, filterId);
  };

  handleApply = filter => {
    this.props.applyCardFilter(this.props.cardId, filter);
  };

  handleFilterGroupApply = filterGroupIds => {
    this.props.applyCardFilterGroups(this.props.cardId, filterGroupIds);
  };

  render() {
    return (
      <DataSourceFilters
        dataSourceId={this.props.dataSourceId}
        filters={this.props.filters}
        onAdd={this.handleAdd}
        onApply={this.handleApply}
        onFilterGroupApply={this.handleFilterGroupApply}
        onRemove={this.handleRemove}
        pageId={this.props.pageId}
        cardId={this.props.cardId}
        canSelectFilterGroups={true}
        selectedFilterGroupIds={this.props.filterGroupIds}
      />
    );
  }
}
export default connect(
  (state, {cardId}) => ({
    dataSourceId: selectDataSourceIdByCardId(state, cardId),
    filters: selectFiltersByCardId(state, cardId),
    filterGroupIds: selectFilterGroupsByCardId(state, cardId),
  }),
  {
    loadDataSourcesByCardId,
    addCardFilter,
    applyCardFilter,
    applyCardFilterGroups,
    removeCardFilter,
  }
)(CardDataSourceFilters);
